import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, of, from } from 'rxjs';
import { AuthenticationService } from './authentication-service/authentication.service';
import { switchMap, take, tap, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { BaseAuthInterceptor } from '@nx-c4g/c4g-auth';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor extends BaseAuthInterceptor<AuthenticationService> implements HttpInterceptor {
  constructor(
    auth: AuthenticationService,
    private dialogRef: MatDialog
  ) {
    super(auth);
  }

  protected override onForbiddenError(err: any): void {
    this.dialogRef.closeAll();
    super.onForbiddenError(err);
  }
}
